
/*
	https://developer.mozilla.org/en-US/docs/Web/API/History/scrollRestoration
*/

const historyScrollRestoration = ( _default ) => 
{
	
	// Handle before unload when on-site page change
	document.querySelectorAll( 'a' ).forEach( ( _entry, _i ) => 
	{
		_entry.addEventListener( 'click', ( _event ) => 
		{
			if ( !_event.currentTarget.getAttribute( 'download' ) &&
				  !_event.currentTarget.getAttribute( 'target' ) === '_blank' &&
				  !_event.currentTarget.getAttribute( 'href' ).startsWith( 'https://www.zmax.com') 
			) {

				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'instant',
				});
			}

		});

	});

	if ('scrollRestoration' in history) 
	{
		history.scrollRestoration = _default;
	}

	return;
}

export {
	historyScrollRestoration
}